import { useState } from "react";
import { useLang, speaksLang } from "@/context/LangContext";
import { useApi } from "@/lib/api";
import { TourCard } from "@/components/site/TourCard";
import { CarCard, GuideCard } from "@/components/site/ServiceCards";
import { PageHero } from "@/components/site/SectionHead";
import BookingDialog from "@/components/site/BookingDialog";

function CatalogPage({ path, titleKey, subKey, testid, render, cols, sort }) {
  const { t, lang } = useLang();
  const raw = useApi(path).data;
  const data = sort && raw ? sort(raw, lang) : raw;
  const [booking, setBooking] = useState(null);
  return (
    <div data-testid={testid}>
      <PageHero title={t(titleKey)} sub={t(subKey)} />
      <section className={`mx-auto grid max-w-7xl gap-6 px-4 sm:px-6 lg:px-8 ${cols}`}>{(data || []).map((x, i) => render(x, i, setBooking))}</section>
      {booking && <BookingDialog key={booking.type + booking.slug} item={booking} onClose={() => setBooking(null)} />}
    </div>
  );
}

export const ToursPage = () => <CatalogPage path="/tours" titleKey="tours_title" subKey="tours_sub" testid="tours-page" cols="md:grid-cols-2 lg:grid-cols-3" render={(x, i, b) => <TourCard key={x.slug} tour={x} i={i} onBook={b} />} />;
export const CarsPage = () => <CatalogPage path="/cars" titleKey="cars_title" subKey="cars_sub" testid="cars-page" cols="md:grid-cols-2 lg:grid-cols-3" render={(x, i, b) => <CarCard key={x.slug} car={x} onBook={b} />} />;
export const GuidesPage = () => <CatalogPage path="/guides" titleKey="guides_title" subKey="guides_sub" testid="guides-page" cols="md:grid-cols-2 lg:grid-cols-3" sort={(gs, l) => (l === "id" ? gs : [...gs].sort((a, b) => speaksLang(b, l) - speaksLang(a, l)))} render={(x, i, b) => <GuideCard key={x.slug} g={x} onBook={b} />} />;
